import { connect } from 'react-redux';

import PresentationComponent from '../../components/dashboards/tabcomponents/TemplateDrawer';
import {
  createTemplate,
  deleteTemplate,
  resetTemplate,
  toggleTemplate,
  updateTemplate,
} from '../../actions/dashboards/templates';
import {
  getFilteredTemplatesByType,
  getUsersColumns,
  getUsersEvent,
  getUsersIdUsingTemplate,
  isUsersAggregateEnabled,
} from '../../reducers/analyticsApp';
import { USER_TEMPLATE_TYPE } from '../../constants/dashboards';
import { setErrorMessage } from '../../actions/application';
import { validation } from '../../utils/dashboards';

const composeTemplateDescription = ({ event, columns }) =>
  event ? `${event}  ${columns.map((col) => ` by ${col.value}`)}` : '';

const mapStateToProps = (state) => ({
  templates: getFilteredTemplatesByType(state, USER_TEMPLATE_TYPE),
  idUsingTemplate: getUsersIdUsingTemplate(state),
  descriptionParams: {
    event: getUsersEvent(state),
    columns: getUsersColumns(state),
    isAggregateEnabled: isUsersAggregateEnabled(state),
  },
});

const mapDispatchToProps = {
  onReset: () => resetTemplate(USER_TEMPLATE_TYPE),
  createTemplate: (templateName, templateDescription) =>
    createTemplate(templateName, templateDescription, USER_TEMPLATE_TYPE),
  updateTemplate: (templateName, templateDescription) =>
    updateTemplate(templateName, templateDescription, USER_TEMPLATE_TYPE),
  onToggle: (template) => toggleTemplate(template),
  setErrorMessage: (message) => setErrorMessage(message),
  onDelete: (id) => deleteTemplate(id),
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  composeDescription: (setDescription) => {
    setDescription(composeTemplateDescription(stateProps.descriptionParams));
  },
  onCreate: (templateName, templateDescription) =>
    validation(
      dispatchProps.setErrorMessage,
      templateName,
      templateDescription,
      dispatchProps.createTemplate
    ),
  onUpdate: (templateName, templateDescription) =>
    validation(
      dispatchProps.setErrorMessage,
      templateName,
      templateDescription,
      dispatchProps.updateTemplate
    ),
});

const UsersTemplateDrawer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PresentationComponent);

export default UsersTemplateDrawer;
